import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export default function DynamicForm() {
    return (_jsx("div", {}));
}
